import React from "react";
import { downloadLink } from "./constFIles";

/* The two initials a person is known by when they have no picture. */
export const initials = (name) => {
    if (!name) return "?";
    const parts = String(name).trim().split(/\s+/);
    return ((parts[0] ? parts[0][0] : "") +
        (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
};

/* The picture is laid over the initials rather than swapped for them (see
   .wh-person in tables.scss), so a missing file, a deleted upload or a slow
   network simply reveals the fallback underneath instead of leaving a hole.
   Must be rendered inside a .wh-person container for that stacking to work. */
const PersonAvatar = ({ name, pic, size = "wh-avatar-sm" }) => (
    <>
        {pic
            ? <img className={`wh-avatar ${size}`}
                src={downloadLink + pic}
                alt=""
                onError={(e) => { e.currentTarget.style.display = "none"; }} />
            : null}
        <span className={`wh-avatar ${size}`}>{initials(name)}</span>
    </>
);

export default PersonAvatar;
